import { useMemo } from 'react'
import { IssueTable, TableSkeleton } from '@/components/tables/issue-table'
import { CLOSED_COLUMNS } from '@/components/tables/issue-columns'
import { ViewHeader } from '@/components/shell/view-header'
import { SortMenu } from '@/components/common/sort-menu'
import { useClosedIssues } from '@/lib/query'
import { ViewError } from '@/components/common/query-states'
import { sortIssues } from '@/lib/sort'
import { useSortPreference } from '@/hooks/use-sort-preference'

/** Closed issues live outside the open-only universe — own query, read-only. */
export default function Closed() {
  const { data: issues, isPending, isError, error, refetch } = useClosedIssues()
  const [sort] = useSortPreference()
  const items = useMemo(() => sortIssues(issues ?? [], sort), [issues, sort])

  return (
    <div className="flex h-full flex-col">
      <ViewHeader
        title="Recently closed"
        meta={`${issues?.length ?? 0} closed issues (most recently updated, up to 50) · reopen from the sheet if closed by mistake`}
        chips={null}
        toolbar={<SortMenu />}
      />
      {isError ? <ViewError what="closed issues" error={error} onRetry={() => refetch()} /> : isPending ? <TableSkeleton /> : <IssueTable issues={items} columns={CLOSED_COLUMNS} bulkKind="closed" />}
    </div>
  )
}
